module.exports = __webpack_public_path__ + "media/images/shared/side_menus/icons/signout-7ccc193156ba82481db26b85d2d35e7b.png";